import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={16.179}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 41382 65737"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974225759552">
        <path
          d="M17893 65737h5595c3540 0 6413-2733 6700-6200H11196c288 3467 3158 6200 6697 6200zM11145 50730l-4 4403h19101l-2-4403zM25930 19383c-38-1704-889-3202-2182-4134l4444-5235c1302 1104 2357 2420 3142 3881 759 1473 1249 3088 1424 4786l-6828 702zm-5237 12150c-1660-15-3313-335-4899-971l2566-6378c706 351 1490 570 2333 570s1627-218 2333-572l2565 6380c-1584 636-3240 956-4898 971zM8626 18681c173-1699 664-3313 1423-4786 784-1461 1841-2777 3143-3881l4444 5236c-1293 932-2144 2430-2183 4133l-6827-702zm12067-2228c1684 0 3049 1367 3049 3051s-1365 3049-3049 3049c-1686 0-3051-1365-3051-3049 0-1685 1365-3050 3051-3051zm0-16453C9266 0 0 9264 0 20691c1 4821 1659 9246 4432 12759 2427 3080 4725 6445 6720 9831l-2 3045h19088l-2-3043c1997-3408 4267-6725 6715-9825 2772-3514 4431-7942 4431-12767C41382 9264 32121 0 20693 0z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
